import React, { useContext } from 'react';

import { ViewerContext } from 'common/containers/ViewerContainer';

import type { Company, Viewer } from 'common/api/endpoints/viewer';

type Props = {
  children: React.ReactNode;
  companyID?: string;
};

export const DevelopersCompanyContext = React.createContext<Company | null>(null);

const DevelopersCompanyContainer = ({ companyID, children }: Props) => {
  const viewer = useContext<Viewer>(ViewerContext);

  let company;
  if (viewer && companyID) {
    company = viewer.companies?.find((company) => {
      return company._id === companyID;
    });
  }

  return (
    <DevelopersCompanyContext.Provider value={company ?? null}>
      {children}
    </DevelopersCompanyContext.Provider>
  );
};

export default DevelopersCompanyContainer;
